import React, { useState } from 'react'
import {
  Button, Row, Col, Drawer,
} from 'antd'

import { useIsSmallDevice } from '../hookreducer/hooks'

import __, { language } from '../languages/parser'

import { getCartArray, formatPrice, getTotalPrice } from '../engine/prices'

import {
  COLOR_URLS,
} from '../static/url'

const baseUrl = process.env.NODE_ENV === 'development'
  ? 'https://gassien.com'
  : ''

const languageUrl = language === 'fr'
  ? ''
  : `/${language}`

const cutArray = (array, maxSize) => {
  const result = []
  for (let i = 0; i < array.length; i += maxSize) {
    result.push(array.slice(i, i + maxSize).join(','))
  }
  return result
}

const fetchEnSerie = (i, curRes, urls, callback) => {
  if (i === urls.length) {
    callback(null, curRes)
    return
  }

  fetch(urls[i], { credentials: 'include' })
    .then((res) => (res.status === 200 ? fetchEnSerie(i + 1, [...curRes, res], urls, callback) : callback('bad response')))
    .catch((err) => callback(err))
}

const order = (items, callback) => {
  const itemsInArray = items
    .map((el) => (el.qty && el.qty > 1 ? `${el.id}:${el.qty}` : el.id))

  const cutedArray = cutArray(itemsInArray, 10)

  fetchEnSerie(0, [], cutedArray.map((el) => `/cart/?add-to-cart-maker=${el}`), (err, res) => {
    if (!err) {
      callback(null, res)
    } else {
      callback(err)
    }
  })
}

const resetAndOrder = (items, callback) => {
  const resetUrl = '/cart/?clear-cart'

  fetch(resetUrl, { credentials: 'include' })
    .then(() => {
      order(items, callback)
    })
}

const Total = ({ totalHt, totalTtc }) => {
  const isSmall = useIsSmallDevice()
  return (
    <div>
      <Row style={{ fontWeight: '600', width: '100%' }}>
        <Col span={isSmall ? 16 : 20}>
          {__('TOTAL HT')}
        </Col>
        <Col offset={1} span={isSmall ? 7 : 3}>
          {formatPrice(totalHt)}
        </Col>
      </Row>

      <Row style={{ fontWeight: '600' }}>
        <Col span={isSmall ? 16 : 20}>
          {__('TOTAL TTC')}
        </Col>
        <Col offset={1} span={isSmall ? 7 : 3}>
          {formatPrice(totalTtc)}
        </Col>
      </Row>
    </div>
  )
}

const SwatchContent = ({ color }) => {
  const isSmall = useIsSmallDevice

  return (
    <Row style={{ width: '100%', marginBottom: isSmall ? '10px' : 0 }}>
      <Col span={6} offset={isSmall ? 2 : 0} style={{ textAlign: 'center' }}>
        <img src={COLOR_URLS[color]} alt={__(color)} style={{ height: '28px', marginTop: '-2px' }} />
      </Col>
      <Col span={isSmall ? 16 : 18}>
        <span style={{ fontWeight: 600, textTransform: 'uppercase', paddingLeft: isSmall ? '4px' : 0 }}>{__(color)}</span>
      </Col>
    </Row>
  )
}

const RecapCart = ({ metalColor, woodColor }) => {
  const isSmall = useIsSmallDevice
  const title = {
    fontWeight: '300',
    textAlign: 'right',
  }
  return (
    <>
      {__('Configuration').toUpperCase()}
      <Row style={{ marginTop: '1em', textAlign: 'left' }}>
        <Col span={isSmall ? 12 : 6} style={title}>
          {`${__('Wall bases')} :`}
        </Col>
        <Col span={isSmall ? 12 : 6}>
          <SwatchContent color={metalColor} />
        </Col>
        <Col offset={isSmall ? 0 : 1} span={isSmall ? 12 : 5} style={title}>
          {`${__('Boards')} :`}
        </Col>
        <Col span={isSmall ? 12 : 6}>
          <SwatchContent color={woodColor} />
        </Col>
      </Row>
    </>
  )
}

const TableHeaderSmall = () => (
  <Row
    style={{
      marginBottom: '0.6em', borderBottom: '1px solid #DDDDDD', paddingBottom: '0.6em', fontWeight: '600',
    }}
  >
    <Col offset={5} span={7}>
      {__('Price (incl. taxes)')}
    </Col>
    <Col offset={1} span={3}>
      {__('Qty')}
    </Col>
    <Col offset={1} span={7}>
      {__('Total')}
    </Col>
  </Row>
)

const TableHeader = () => (
  <Row
    style={{
      marginBottom: '0.6em', borderBottom: '1px solid #DDDDDD', paddingBottom: '0.6em', fontWeight: '600',
    }}
  >
    <Col offset={3} span={9} style={{ textAlign: 'left' }}>
      {__('Name')}
    </Col>
    <Col offset={1} span={3}>
      {__('Price (incl. taxes)')}
    </Col>
    <Col offset={1} span={3}>
      {__('Quantities')}
    </Col>
    <Col offset={1} span={3}>
      {__('Total')}
    </Col>
  </Row>
)

const TableHeaderContainer = (props) => {
  const isSmall = useIsSmallDevice
  return isSmall ? <TableHeaderSmall {...props} /> : <TableHeader {...props} />
}

const ElementSmall = ({
  name, qty, unitaryPriceTTC, img,
}) => (
  <>
    <Row style={{ marginBottom: '0.4em' }}>
      <Col span={2}>
        <img src={baseUrl + img} alt={name} style={{ width: '100%' }} />
      </Col>
      <Col offset={1} span={21} style={{ textAlign: 'left' }}>{name}</Col>
    </Row>
    <Row style={{ marginBottom: '0.4em', borderBottom: '1px solid #DDDDDD' }}>
      <Col offset={5} span={7}>
        {formatPrice(unitaryPriceTTC)}
      </Col>
      <Col offset={1} span={3}>{qty}</Col>
      <Col offset={1} span={7}>
        {formatPrice(unitaryPriceTTC * qty)}
      </Col>
    </Row>
  </>
)

const Element = ({
  name, qty, unitaryPriceTTC, img,
}) => (
  <Row style={{ marginBottom: '0.4em' }}>
    <Col span={2}>
      <img src={baseUrl + img} alt={name} style={{ width: '100%' }} />
    </Col>
    <Col offset={1} span={9} style={{ textAlign: 'left' }}>{name}</Col>
    <Col offset={1} span={3}>
      {formatPrice(unitaryPriceTTC)}
    </Col>
    <Col offset={1} span={3}>{qty}</Col>
    <Col offset={1} span={3}>
      {formatPrice(unitaryPriceTTC * qty)}
    </Col>
  </Row>
)

const ElementContainer = (props) => {
  const isSmall = useIsSmallDevice
  return isSmall ? <ElementSmall {...props} /> : <Element {...props} />
}

const AddToCart = ({ handleOrder, resetCartAndHandleOrder, orderState }) => (
  <>
    <Button
      type="primary"
      block
      shape="round"
      onClick={handleOrder}
      loading={orderState === 'order'}
      disabled={orderState === 'resetAndOrder'}
      style={{ textTransform: 'uppercase', marginBottom: '1em' }}
    >
      {__('Add my composition to current cart')}
    </Button>
    <Button
      disabled={orderState === 'order'}
      type="primary"
      shape="round"
      block
      onClick={resetCartAndHandleOrder}
      loading={orderState === 'resetAndOrder'}
      style={{ textTransform: 'uppercase' }}
    >
      {__('Reset my current cart and add composition')}
    </Button>
  </>
)


const Cart = ({
  cartArray, totalHt, totalTtc,
}) => (
  <>
    <div style={{ textAlign: 'right' }}>
      <TableHeaderContainer />
      {cartArray.map((el) => (
        <ElementContainer
          key={el.id}
          id={el.id}
          name={el.name}
          qty={el.qty}
          metalColor={el.metalColor}
          woodColor={el.woodColor}
          unitaryPriceTTC={el.priceTtc}
          img={el.img}
        />
      ))}
      <Total totalHt={totalHt} totalTtc={totalTtc} />
    </div>

  </>
)

const CartDrawer = ({
  cartVisibility, setCartVisibility, elements, metalColor, woodColor,
}) => {
  const [orderState, setOrderState] = useState('none')

  const { cart, cartArray } = getCartArray(elements, metalColor, woodColor)
  const { totalHt, totalTtc } = getTotalPrice(elements, metalColor, woodColor)

  const isSmall = useIsSmallDevice()

  const handleOrder = () => {
    setOrderState('order')
    order(Object.keys(cart).map((el) => cart[el]), () => {
      document.location = `${languageUrl}/cart`
    })
  }

  const resetCartAndHandleOrder = () => {
    setOrderState('resetAndOrder')
    resetAndOrder(Object.keys(cart).map((el) => cart[el]), () => {
      document.location = `${languageUrl}/cart`
    })
  }

  return (
    <Drawer
      title={<RecapCart metalColor={metalColor} woodColor={woodColor} />}
      placement="right"
      closable={false}
      onClose={() => setCartVisibility(false)}
      visible={cartVisibility}
      width={isSmall ? '90%' : '50%'}
      zIndex={1000000}
      footer={(
        <AddToCart
          handleOrder={handleOrder}
          resetCartAndHandleOrder={resetCartAndHandleOrder}
          orderState={orderState}
        />
)}
    >
      <Cart
        cartArray={cartArray}
        totalHt={totalHt}
        totalTtc={totalTtc}
        metalColor={metalColor}
        woodColor={woodColor}
      />
    </Drawer>
  )
}

export default CartDrawer
